import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import {  Attach } from '../../models/anexos.model';
import { ActivatedRoute } from '@angular/router';
import { AnexosService } from '../../services/anexos.service';
import { AnexosResolverId } from '../../resolver/anexos.resolver';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-anexos-edit',
  templateUrl: './anexos-edit.component.html',
  styleUrls: ['./anexos-edit.component.scss']
})
export class AnexosEditComponent extends BaseFormComponent<Attach> implements OnInit {

  actionLabel: string = 'Novo';
  data: Attach;
  selectedFile: File | null = null;
  @Input() id:number;
  @Input() attach_id:number = null;
  @Output() closeModal = new EventEmitter<void>();
  @Output() excluir = new EventEmitter<void>();

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: AnexosService,
    public anexosResolverId: AnexosResolverId
  ) {
      super(activatedRoute);
  }

  ngOnInit() {
    this.loading();
    this.initForm();
    this.start();
  }

  initForm() {
    this.form = new FormGroup({
      meeting_id: new FormControl(this.id, [Validators.required]),
      title: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      file: new FormControl(null),
    });
    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }
  start(){
    if(this.attach_id && this.attach_id != 0){
      this.anexosResolverId.getAttachById(this.attach_id ).subscribe({
        next: (data) => {
          this.entity = data;
          this.data = data;
          this.initForm();
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          this.msgError(error.error.message);
        }
      })
    }
    else{
      this.loaded();
    }
  }
  getDataCreate() {
    return Object.assign({}, this.form.value);
  }
  salvar() {
    if (this.form.valid) {
      this.loading();
      var newData = this.getDataCreate();
      this.addSub(
        this.myService.uploadFile(this.attach_id,newData, this.selectedFile).subscribe({
          next: (res) => {
            this.loaded();
            this.confirmation('Anexo criado com sucesso!').subscribe(() => {
              window.location.reload();
            });
          },
          error: (error) => {
            let msg = error?.error?.message;
            this.msgError(msg);
              this.loaded();
          },
        })
      );
    }
    else {
      this.markAsDirty();
    }
  }
  onFileSelected(event: any): void {
    this.selectedFile = event?.target?.files[0];
  }

  onCloseModal(){
    this.closeModal.emit();
  }
  onExcluir(){
    this.excluir.emit();
  }
  //detecta o ctrl+s, evita que o navegador faça o evento padrão e chama a função de salvar
  @HostListener('document:keydown.control.s', ['$event'])
  onCtrlS(event: KeyboardEvent): void {
    event.preventDefault(); 
    this.salvar();
  }

}
